export enum AssetAdditionType {
	NewAsset,
	CipAssetConversion,
	CipExpenseConversion,
	AdditionToExistingAsset,
	CipExistingAssetConversion,
}
